export default __webpack_public_path__ + "7bd62d583d348b7fc9ab2b34e8553bd9.png";